import { TZDate } from "@date-fns/tz";
import { subDays } from "date-fns";

const SUNDAY = 0;
const SATURDAY = 6;

/** How many days to go back from a weekday to reach the previous working day. */
const getDaysBackToWorkingDay = (weekday: number) => {
  switch (weekday) {
    case SUNDAY:
      return 2;
    case SATURDAY:
      return 1;
    default:
      return 0;
  }
};

/**
 * When the reminder goes out: 24h before the appointment, moved back to the previous working day
 * when that lands on a weekend. Mirrors `getAppointmentReminderScheduledAt` in bbj-package, which
 * the back re-applies on save: actions and workshops must both read the date the same way.
 */
export const getAppointmentReminderScheduledAt = (startDateTime: Date, timeZone: string) => {
  const reminderDate = subDays(new TZDate(startDateTime.getTime(), timeZone), 1);
  return subDays(reminderDate, getDaysBackToWorkingDay(reminderDate.getDay()));
};

/** Whether a reminder for this appointment could still be sent, its send date being ahead. */
export const isAppointmentReminderSchedulable = (startDateTime: Date, timeZone: string) =>
  getAppointmentReminderScheduledAt(startDateTime, timeZone).getTime() > Date.now();
